import {
  ASSET_CLASS_MODELS,
  FIELDS
} from '../../shared/screener-constants';

const assetClass = () => {
  return {
    [ASSET_CLASS_MODELS.ALL]: {
      key: 'asset-all',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'All',
      value: 'All',
      modelKey: ASSET_CLASS_MODELS.ALL,
      checked: true
    },
    [ASSET_CLASS_MODELS.EQUITIES]: {
      key: 'equities',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Equities',
      value: 'Equities',
      modelKey: ASSET_CLASS_MODELS.EQUITIES,
      checked: true
    },
    [ASSET_CLASS_MODELS.FIXEDINCOME]: {
      key: 'fixed-income',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Fixed Income',
      value: 'Fixed Income',
      modelKey: ASSET_CLASS_MODELS.FIXEDINCOME,
      checked: true
    },
    [ASSET_CLASS_MODELS.GUARANTEED]: {
      key: 'guaranteed',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Guaranteed',
      value: 'Guaranteed',
      modelKey: ASSET_CLASS_MODELS.GUARANTEED,
      checked: true
    },
    [ASSET_CLASS_MODELS.MONEYMARKET]: {
      key: 'money-market',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Money Market',
      value: 'Money Market',
      modelKey: ASSET_CLASS_MODELS.MONEYMARKET,
      checked: true
    },
    [ASSET_CLASS_MODELS.MULTIASSET]: {
      key: 'multi-asset',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Multi-Asset',
      value: 'Multi-Asset',
      modelKey: ASSET_CLASS_MODELS.MULTIASSET,
      checked: true
    },
    [ASSET_CLASS_MODELS.OTHER]: {
      key: 'asset-other',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Other',
      value: 'Other',
      modelKey: ASSET_CLASS_MODELS.OTHER,
      checked: true
    },
    [ASSET_CLASS_MODELS.REALESTATE]: {
      key: 'real-estate',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Real Estate',
      value: 'Real Estate',
      modelKey: ASSET_CLASS_MODELS.REALESTATE,
      checked: true
    },
    [ASSET_CLASS_MODELS.TARGETDATE]: {
      key: 'target-date',
      fieldKey: FIELDS.ASSETCLASS,
      label: 'Target Date',
      value: 'Target Date',
      modelKey: ASSET_CLASS_MODELS.TARGETDATE,
      checked: true
    }
  };
};

export default assetClass;
